import React, { useState } from "react";
import "../../../static/css/App.css";
import OrderTable from "../orderTable";
const CancelledOrders = () => {
  return (
    <>
      <OrderTable status={3} isActive="cancelled" />
    </>
  );
};

export default CancelledOrders;
